<!-- Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. -->

<mat-card class="password-policy-rules">
	<mat-card-header>
		<mat-card-title class="password-policy-title">Password Requirements</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		<ul>
			<li>at least 10 characters long</li>
			<li>at least one lowercase letter</li>
			<li>at least one uppercase letter</li>
			<li>at least one special character</li>
		</ul>
	</mat-card-content>
</mat-card>
